import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useTranslations from "@hooks/useTranslations";
import { useWindow } from "@hooks/useWindow";
const PrintButton = () => {
    const { t } = useTranslations();
    const myWindow = useWindow();
    return (_jsxs("button", { className: "btn btn--tertiary-icon", onClick: () => myWindow.print(), children: [_jsx("span", { className: "btn-circle btn-circle--outlined btn-circle--animated", children: _jsx("span", { className: "btn-icon material-symbols-outlined", children: "print" }) }), _jsx("span", { className: "btn-text animated-link", children: _jsx("span", { className: "hover-underline", children: t("BDO.LiveSite.Print") }) })] }));
};
export default PrintButton;
